import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import ShowColumn from './sessionJoinDialogSelectColumnsList.component';

const styles = () => ({
  block: {
    overflow: 'auto',
    maxHeight: '500px',
    display: 'inline-flex',
  },
});

class SelectJoinColumns extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [],
    };

    this.getHeaderSettings = this.getHeaderSettings.bind(this);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.block}>
        {this.renderColumns()}
      </div>
    );
  }

  renderColumns() {
    const { session } = this.props;
    const fileWithRequiredHeaders = this.getRequiredHeaders(this.getFileIds());

    return fileWithRequiredHeaders.map((file, index) => (
      <ShowColumn
        key={index}
        index={index}
        file={session.files[file.file]}
        sessionId={session.id}
        lockedHeaders={file.lockedHeaders}
        onChange={this.getHeaderSettings}
      />
    ));
  }

  getHeaderSettings(header, fileId) {
    const headers = [...this.state.headers];
    headers[fileId] = { ...headers[fileId], ...header };

    this.setState({ headers });
    this.props.onChange(headers, fileId);
  }

  getFileIds() {
    const { joins } = this.props;

    const targetfiles = joins.map(join => (!join.targetFile
      ? null
      : join.targetFile
    ));

    const sourcefiles = joins.map(join => (!join.sourceFile
      ? null
      : join.sourceFile
    ));

    const files = [...targetfiles, ...sourcefiles];

    // Remove duplicates and null/undefined values
    return files.filter((item, pos) => {
      return files.indexOf(item) === pos;
    }).filter(item => {
      return item !== null;
    });
  }

  getRequiredHeaders(files) {
    const { joins } = this.props;

    return files.map(file => {
      const lockedHeaders = joins.map(join => {
        if (join.sourceFile === file) {
          return join.sourceHeader;
        } else if (join.targetFile === file) {
          return join.targetHeader;
        }
        return undefined;
      }).filter((header) => {
        return header !== undefined;
      });
      return {
        file: file,
        lockedHeaders: lockedHeaders,
      }
    });
  }
};

SelectJoinColumns.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  joins: PropTypes.array.isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    }),
  }).isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(SelectJoinColumns);
